var exports = {
  "N": "ProfileCardFooter.module__footerSection___RnpMVG",
};

module.exports = exports;
